import React from 'react';
import classnames from 'classnames';

import emailIcon from '../imgs/icon-email.svg';
import { useLanguageChange } from '../helpers/hooks';
import { useTranslation } from 'react-i18next';

import { useComponentVisible } from '../helpers/hooks';

export default function Nav() {
  const { t, i18n } = useTranslation();
  const changeLanguage = useLanguageChange();

  const {
    ref,
    isComponentVisible,
    setIsComponentVisible,
  } = useComponentVisible(false);

  return (
    <header>
      <div className="logo" />
      <div className="header__right">
        <div
          className="support-mob__btn"
          onClick={() => {
            setIsComponentVisible(!isComponentVisible);
          }}
          ref={ref}
        >
          {t('Nav.Support')}
        </div>
        <div
          className={classnames('support-mob__dropdown', {
            show: isComponentVisible,
          })}
        >
          <a
            className="mail-link "
            href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`}
          >
            <img src={emailIcon} alt="" /> {process.env.REACT_APP_SUPPORT_EMAIL}
          </a>
        </div>
        {/* <!-- LANGBAR START --> */}

        <div className="langbar">
          <span
            className={classnames({
              'langbar--active': i18n.language === 'uk',
            })}
            onClick={() => changeLanguage('uk')}
          >
            Ук<span>раїнська</span>
          </span>
          <div className="langbar__divider" />
          <span
            className={classnames({
              'langbar--active': i18n.language === 'en',
            })}
            onClick={() => changeLanguage('en')}
          >
            En<span>glish</span>
          </span>
          <div className="langbar__divider" />
          <span
            className={classnames({
              'langbar--active': i18n.language === 'ru',
            })}
            onClick={() => changeLanguage('ru')}
          >
            Ру<span>сский</span>
          </span>
        </div>

        {/* LANGBAR END */}
      </div>
    </header>
  );
}
